function toArray<T>(arr: ArrayLike<T>): T[] {
    return Array.prototype.slice.call(arr) as T[];
}

// ----------------------------------------------------------------------------

declare global {
    interface NodeList {
        toArray(): any[];
    }
}

// ----------------------------------------------------------------------------

NodeList.prototype.toArray = function (): any[] {
    return toArray(this);
};

// ----------------------------------------------------------------------------

export default toArray;
